module.exports = "/pages/google/Common/Foodslabo/Detail/first_view_background.jpg";